export default {
    dataModel: {
      types: ['cdlt:TargetAudience'],
      fieldsMapping: {
        title: 'pair:label'
      }
    },
  };
  